import { render, staticRenderFns } from "./PassengersPaymentTab.vue?vue&type=template&id=cb6ffdaa&scoped=true&"
import script from "./PassengersPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./PassengersPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./PassengersPaymentTab.vue?vue&type=style&index=0&id=cb6ffdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6ffdaa",
  null
  
)

export default component.exports